<template>
  <section class="p-4">
    <AppHeading>Input Settings</AppHeading>
    <OptimizerSettingsCard
      :card="{ name: 'General Settings', icon: 'chrome_reader_mode' }"
      class="mb-4"
    >
      <SchemaForm
        :fields="generalSchema"
        :value="runData"
        :disabled="true"
      />
    </OptimizerSettingsCard>
    <OptimizerSettingsCard
      :card="{ name: 'Filter', icon: 'filter_list' }"
      class="mb-4"
    >
      <Filters
        :disabled="true"
        :value="runData.settings && runData.settings.filters || {}"
      />
    </OptimizerSettingsCard>
  </section>
</template>

<script>
import Filters from '@sm/client/components/SectionOptimizerOutput/SectionOptimizerFilters'
import SchemaForm from '@/components/Forms/Form'
import FormText from '@/components/Forms/FormText'
import WithSideDescription from '@/components/Forms/WithSideDescription'
import FormDepartmentSelect from '@/components/Forms/FormDepartmentSelect'
import OptimizerSettingsCard from '@sm/client/components/OptimizerExams/OptimizerSettingsCard'
const FormTextWithDesc = WithSideDescription(FormText)
const FormDepartmentSelectWithDesc = WithSideDescription(FormDepartmentSelect)

export default {
  components: {
    Filters,
    SchemaForm,
    OptimizerSettingsCard,
  },
  props: {
    runData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    generalSchema () {
      return [
        {
          name: 'name',
          label: 'Optimizer Run Name',
          placeholder: 'Enter name',
          type: FormTextWithDesc,
          description:
            'Name of optimizer run. For example, Spring 2019 Room Assignment.',
          required: true,
        },
        {
          name: 'departments',
          label: 'Academic Departments',
          placeholder: 'Select Department',
          type: FormDepartmentSelectWithDesc,
          description:
            'This setting is used to run the optimizer for specific academic departments. Default is all departments.',
          required: true,
        },
      ]
    },
  },
}
</script>
